import {Component, ViewChild} from '@angular/core';
import {MatStepper} from '@angular/material';
import {MatDialog} from '@angular/material/dialog';
import {RedistributionFirstStepComponent} from './first-step/redistribution-first-step.component';
import {CommonService} from 'src/app/services/common.service';
import {LoadingService} from 'src/app/services/loading.service';
import {ToastMessagesService} from 'src/app/services/toast-messages.service';
import {RedistributionSecondStepComponent} from './second-step/redistribution-second-step.component';
import {ActionCompletionDialogComponent} from 'src/app/common/action-completion-dialog/action-completion-dialog.component';

@Component({
  templateUrl: './redistribution-dialog.component.html'
})
export class RedistributionDialogComponent {
  @ViewChild('stepper', {static: true}) stepper: MatStepper;
  @ViewChild('firstStep', {static: true}) firstStep: RedistributionFirstStepComponent;
  @ViewChild('secondStep', {static: true}) secondStep: RedistributionSecondStepComponent;

  public isLoading: boolean;
  public firstStepResult: any;
  public checkDescription: string;
  public stock: any;
  public details: any;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService,
  ) {
    this.isLoading = false;
  }

  public goBack(): void {
    this.stepper.previous();
  }

  public setButtonText(): string {
    return this.stepper.selectedIndex === 0 ? 'Επόμενο' : 'Καταχώρηση';
  }

  public setCardTitle(): string {
    return this.stepper.selectedIndex === 0 ? 'Βήμα 1' : 'Βήμα 2';
  }

  public async setSubmitAction(): Promise<void> {
    if (this.stepper.selectedIndex === 0) {
      this.firstStepResult = await this.firstStep.submit();
      if (this.firstStepResult.result.length > 0 ) {
        this.details = this.firstStepResult.result;
        this.stepper.next();
      } else {
        this.toastMessagesService.toastMessages(this.firstStepResult.result.message);
      }
    } else {
      await this.secondStep.submit();
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στα Budget Super Market',
          redirectURL: `super-market-budget`
        }
      });
    }
  }

  public isFormGroupInvalid(): boolean {
    return this.stepper.selectedIndex === 0
      ? this.firstStep && this.firstStep.isFormGroupInvalid()
      : this.secondStep && this.secondStep.isInvalid();
  }
}
